import { createFileRoute } from "@tanstack/react-router";
import { LegalDocument } from "@/features/public/Legal";

export const Route = createFileRoute("/privacy")({ component: () => <LegalDocument doc="privacy" /> });
